import React from 'react'
import { useDispatch } from 'react-redux'
import { Formik } from 'formik'
import * as Yup from 'yup'

import BaseModal from 'components/Modals/BaseModal'
import { Button, Form, Input } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { Alert } from 'ui'
import { createNotification } from 'store/actions/notifications'
import { refreshCounter } from 'store/actions/refresh'

import Api from 'services/Api'

import { t } from 'translations'

const UserUsernameChangeModal = ({ userId }) => {
  const dispatch = useDispatch()

  // Function to validate the uniqueness of the  username
  const validateUsername = async username => {
    if (username) {
      const { message, success } = await Api.post('validate/username', { id: userId, username })
      if (!success) return t(`manager.users.form.${message}.USERNAME`)
    }
    return
  }

  // Form validation
  const EditUsernameShape = {
    username: Yup.string().required('employee.myProfile.MANDATORY_USERNAME')
  }

  const onSubmit = async (values, actions) => {
    const { message, success } = await Api.put('users/users', { ...values, _id: userId })
    if (!success) {
      actions.setSubmitting(false)
      actions.setStatus({ type: 'danger', msg: `employee.myProfile.${message}` })
    } else {
      dispatch(createNotification({ title: t(`components.notification.USERNAME_UPDATED`), description: ``, type: 'success' }))
      !actions.isSubmitting && dispatch(closeModal())
    }
    dispatch(refreshCounter('users'))
  }

  return (
    <BaseModal title="manager.users.CHANGE_USERNAME" hideButtons>
      <Formik validationSchema={Yup.object().shape(EditUsernameShape)} enableReinitialize={true} initialValues={{ username: '' }} onSubmit={onSubmit}>
        {({ status, isSubmitting, dirty, resetForm, setStatus }) => {
          return (
            <Form resetForm={resetForm} dirty={!!dirty && !isSubmitting}>
              {() => (
                <>
                  {/* Error message */}
                  <Alert variant={status?.type} onClose={() => setStatus()} show={!!status?.msg}>
                    {status?.msg}
                  </Alert>

                  <Input module="manager.users.form" required name="username" type="text" autoComplete="false" validate={validateUsername} />

                  <div className="mt-4">
                    <Button className="btn btn-primary mr-2 " type="submit" isSubmitting={isSubmitting} text="employee.attendanceForm.SUBMIT" />
                    <Button className="btn btn-outline-secondary " onClick={() => dispatch(closeModal())}>
                      {t(`actions.CLOSE`)}
                    </Button>
                  </div>
                </>
              )}
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default UserUsernameChangeModal
